import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
